export default __webpack_public_path__ + "static/media/194.61b52eda.png";